import { FormConfigure } from './components/FormConfigure'
import { ProviderAccountLabel } from './components/Label'

export const FeatureProviderAccountShared = {
  Label: ProviderAccountLabel,
  FormConfigure,
}
